import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { MultiSelectModule } from 'primeng/primeng';

import { EntityDocumentsComponent } from 'app/entities/documents/entity-documents.component';
import { DocumentDetailsComponent } from 'app/entities/documents/documentdetails/document-details.component';
import { AddLabelComponent } from 'app/entities/documents/addlabel/add-label.component';
import { EntityDocumentsService } from 'app/entities/documents/entity-documents.service';

@NgModule({
    declarations: [
        EntityDocumentsComponent,
        DocumentDetailsComponent,
        AddLabelComponent,
    ],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        MultiSelectModule
    ],
    providers: [
        EntityDocumentsService,
    ],
    entryComponents: [
        AddLabelComponent
    ],
    exports: [
        EntityDocumentsComponent
    ]
})

/**
 * Main module for the entity documents tab management.
*/
export class EntityDocumentsModule { }



// WEBPACK FOOTER //
// ./src/app/entities/documents/entity-documents.module.ts